import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  CreateApiTokenRequestDto,
  CreateApiTokenResponseDto,
} from '../model';

const createApiToken = async (
  args: CreateApiTokenRequestDto,
  options?: RequestHandlerOptions
): Promise<CreateApiTokenResponseDto> => {
  const request = () =>
    apiClient.post('/security/trading/webapi/token/create', args);

  const response = await handleRequest<CreateApiTokenResponseDto>(
    request,
    options
  );

  return response.data;
};

export { createApiToken };
